/* eslint-disable */
// The fixed selection season + the ONE tolerant season-object reader, as a PURE
// module (no React, no CSS) so utilities and Node-side loaders can import them
// without dragging the chip's JSX along. SelectionChip.js re-exports both, so
// every existing importer keeps its path; this file is the single definition.
// Lifted verbatim from SelectionChip.js (Collection C2, 2026-09-17).

// Task 4 — the FILTER (server-side useDevsPaginated + client mirror useDevFilters)
// targets this FIXED season so the two predicates agree exactly. The chip DISPLAY
// above reads the NEWEST key; with one active season they coincide. Bump this (or
// move to a column) if a second season is ever stamped.
export const SELECTION_SEASON = '2027';

// The two axes are independent (dev-procurement-sync-20260827). `decision` is
// what the season MEETING decided; `procurement` is what the Orders DATA file
// says, written only by the synchroniser. They used to be one field, so marking
// a model ORDER destroyed the IN the meeting had given it — and its date.
const VALID_DECISION = new Set(['in', 'out']);
const VALID_PROCUREMENT = new Set(['order', 'preorder']);

// LEGACY ENCODING — read-only tolerance, deliberately kept.
// Before the migration, `decision` itself carried 'order'/'preorder' for 9 rows.
// readSelectionAt prefers the real `procurement` key and falls back to that old
// encoding, so this file is correct BOTH before and after the SQL package runs
// and there is no window in which David sees the wrong thing. Once every row is
// migrated the fallback is dead code — leave it anyway; removing it is a
// separate one-line change, not a thing to do while the data is in motion.
//
// Reading a legacy 'order'/'preorder' as decision 'in' is not a guess: every
// shipped reader already treats both as in-selection (selectionFields.js IS_IN,
// factoryBits.decisionOf, DevGridFooter), so the rendered meaning is unchanged.

// Returns { decision, procurement } for ONE season object, or null if it carries
// neither axis. Pure — no season pick, no shape guard; callers do that.
// Single implementation, consumed by the newest-season resolver below AND by the
// fixed-season readers (devStatusFilter.matchesSelectionSets, designerFilters),
// so the board and its filters can never disagree about what a row means.
export function readSelectionAt(seasonObj) {
  if (!seasonObj || typeof seasonObj !== 'object') return null;
  const rawDec = seasonObj.decision;
  const rawProc = seasonObj.procurement;
  const procurement = VALID_PROCUREMENT.has(rawProc)
    ? rawProc
    : (VALID_PROCUREMENT.has(rawDec) ? rawDec : null);   // legacy fallback
  const decision = VALID_DECISION.has(rawDec)
    ? rawDec
    : (VALID_PROCUREMENT.has(rawDec) ? 'in' : null);     // legacy fallback
  if (!decision && !procurement) return null;
  return { decision, procurement };
}
